import { makeStyles } from '@material-ui/core/styles';

// Ember expressive dot spinner. Twelve orbiting dots + a center logo. Sizing
// follows `--spinner-size` (default 112px); inner dimensions and the
// `--orbit-radius` derive from it so the design scales proportionally.
const styles = () => ({
  '@keyframes emberExpressiveOrbit': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  },
  '@keyframes emberExpressiveBreathe': {
    '0%, 100%': { transform: 'scale(0.98)', filter: 'saturate(0.98)' },
    '50%': { transform: 'scale(1.02)', filter: 'saturate(1.06)' }
  },
  // Each dot rotates between its `--mid-angle` and 0deg with a small overshoot
  // — see design's dev-handoff.html. The CSS-var-based translateY keeps the
  // orbit radius proportional to --spinner-size.
  '@keyframes emberExpressiveArcAsym': {
    '0%': {
      transform:
        'rotate(calc(var(--mid-angle, 0) * 1deg)) translateY(calc(-1 * var(--orbit-radius))) rotate(calc(var(--mid-angle, 0) * -1deg))'
    },
    '56%': {
      transform: 'rotate(0deg) translateY(calc(-1 * var(--orbit-radius))) rotate(0deg)'
    },
    '64%': {
      transform: 'rotate(14deg) translateY(calc(-1 * var(--orbit-radius))) rotate(-14deg)'
    },
    '78%': {
      transform:
        'rotate(calc(var(--mid-angle, 0) * 0.56deg)) translateY(calc(-1 * var(--orbit-radius))) rotate(calc(var(--mid-angle, 0) * -0.56deg))'
    },
    '100%': {
      transform:
        'rotate(calc(var(--mid-angle, 0) * 1deg)) translateY(calc(-1 * var(--orbit-radius))) rotate(calc(var(--mid-angle, 0) * -1deg))'
    }
  },
  wrap: {
    width: 'var(--spinner-size, 112px)',
    height: 'var(--spinner-size, 112px)',
    position: 'relative',
    display: 'inline-grid',
    placeItems: 'center'
  },
  orbit: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 'calc(var(--spinner-size, 112px) * 100 / 112)',
    height: 'calc(var(--spinner-size, 112px) * 100 / 112)',
    marginLeft: 'calc(var(--spinner-size, 112px) * -50 / 112)',
    marginTop: 'calc(var(--spinner-size, 112px) * -50 / 112)',
    animation: '$emberExpressiveOrbit 1.6s linear infinite'
  },
  dotTrack: {
    position: 'absolute',
    inset: 0
  },
  dot: {
    '--orbit-radius': 'calc(var(--spinner-size, 112px) * 50 / 112)',
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 'calc(var(--spinner-size, 112px) * 6 / 112)',
    height: 'calc(var(--spinner-size, 112px) * 6 / 112)',
    marginLeft: 'calc(var(--spinner-size, 112px) * -3 / 112)',
    marginTop: 'calc(var(--spinner-size, 112px) * -3 / 112)',
    borderRadius: '50%',
    flex: '0 0 auto',
    transformOrigin: 'center',
    animation: '$emberExpressiveArcAsym 1.25s linear infinite'
  },
  center: {
    width: 'calc(var(--spinner-size, 112px) * 64 / 112)',
    height: 'calc(var(--spinner-size, 112px) * 80 / 112)',
    objectFit: 'contain',
    pointerEvents: 'none',
    animation: '$emberExpressiveBreathe 1.7s ease-in-out infinite'
  }
});

export default makeStyles(styles);
